export const formatMoneyToBRL = (currency: number): string => {
  const formattedCurrency = Number(currency).toLocaleString('pt-br', {
    style: 'currency',
    currency: 'BRL'
  });
  return formattedCurrency.replace(/\u00A0/, ' ');
};
